function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "17.661",
  height: "15.661",
  viewBox: "0 0 17.661 17.661"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2029",
  "data-name": "Rectangle 2029",
  fill: "none",
  d: "M0 0h17.661v17.661H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4803",
  "data-name": "Group 4803"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4802",
  "data-name": "Group 4802",
  clipPath: "url(#clip-path)",
  fill: "#282828"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2571",
  "data-name": "Path 2571",
  d: "M17.206 10.135l-7.071 7.071a1.554 1.554 0 01-2.2 0L.454 9.721A1.538 1.538 0 010 8.623V1.552A1.553 1.553 0 011.552 0h7.071a1.538 1.538 0 011.1.454l7.485 7.485a1.554 1.554 0 010 2.2m-15.97-8.9a.447.447 0 00-.132.316v7.068a.451.451 0 00.132.316l7.485 7.486a.449.449 0 00.633 0l7.071-7.071a.449.449 0 000-.633L8.939 1.236a.451.451 0 00-.316-.136H1.552a.447.447 0 00-.316.132"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2572",
  "data-name": "Path 2572",
  d: "M5.186 5.186a1.553 1.553 0 110-2.2 1.554 1.554 0 010 2.2M3.772 3.772a.448.448 0 10.633 0 .448.448 0 00-.633 0"
})))));